import { BaseEntity, type Searchable } from './base'

export class Portfolio extends BaseEntity implements Searchable {
  displayName!: string
  createdAt!: string

  get searchString() {
    return this.displayName
  }
}

export class PortfolioWithCaseCount extends Portfolio {
  _count!: {
    cases: number
  }
}

export class NewPortfolio {
  displayName!: string
}

export class UpdatePortfolio {
  displayName?: string
}

export interface GetPortfolios {
  portfolios: Portfolio[]
}

export interface GetPortfoliosWithCaseCount {
  portfolios: PortfolioWithCaseCount[]
}

export interface PortfolioWritten {
  portfolio: Portfolio
}
